import { InjectionToken } from '@angular/core';
import type { AuthServiceInterface } from './auth-service.interface';

export const AUTH_SERVICE_INJECTION_TOKEN = new InjectionToken<AuthServiceInterface<any, any>>(
  'authService',
);
